const animatedElements = document.querySelectorAll("[data-animated]");

let i;
if(animatedElements) {
    for (i = 0; i < animatedElements.length; i++) {
        animateElementsAlreadyScrolled(animatedElements[i], animatedElements[i].dataset.animationTriggerBuffer);
    }
}

function animateElementsAlreadyScrolled (el, triggerBuffer) {
    const rect = el.getBoundingClientRect();
    if (rect.top + (triggerBuffer || 0) <= window.scrollY || shouldTriggerAnimation(el, triggerBuffer)) {
        el.classList.add("animation-triggered");
    }
}

document.addEventListener('scroll', function (e) {
  if(animatedElements) {
    for (i = 0; i < animatedElements.length; i++) {
        const currElement = animatedElements[i];
        const triggerBuffer = currElement.dataset.animationTriggerBuffer;
        if(shouldTriggerAnimation(currElement, triggerBuffer)) {
            currElement.classList.add("animation-triggered");
        }
    }
  }
})

function shouldTriggerAnimation(el, triggerBuffer) {
    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

    const elementInView = (rect.top <= windowHeight - (triggerBuffer || 100) /**pixel buffer not to start animation as soon as top of element is visible. */)
                            && ((rect.top + rect.height) >= 0);

    return (elementInView);
}

